<template>
  <img src="@/assets/img/campaign/ouencampaign.jpg" />
</template>


<style scoped>
</style>

<script>
</script>